import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { useIntl } from 'react-intl';
import { User } from 'utils/apiClient/services/contacts/types';

const { Option } = Select;

export interface EmployeesFilterProps {
  handleUsersFilterChange: (values: number[]) => void;
  employees: Array<User> | undefined;
}

const EmployeesFilter: React.FC<EmployeesFilterProps> = ({
  handleUsersFilterChange,
  employees,
}) => {
  const intl = useIntl();
  const [selectedValues, setSelectedValues] = useState<number[]>([]);

  const handleSelectChange = (values: number[]) => {
    if (values.includes(-1)) {
      handleUsersFilterChange(
        employees ? employees.map((user) => user.id) : []
      );
      setSelectedValues(
        employees ? [-1, ...employees.map((user) => user.id)] : []
      );
    } else {
      setSelectedValues(values);
      handleUsersFilterChange(values);
    }
  };

  useEffect(() => {
    setSelectedValues(
      [-1].concat(employees ? employees.map((user) => user.id) : [])
    );
  }, [employees]);

  return (
    <Select
      mode="multiple"
      placeholder={intl.formatMessage({ defaultMessage: 'Filter by Employee' })}
      dropdownStyle={{ minWidth: 150 }}
      style={{ minWidth: 150 }}
      popupMatchSelectWidth={false}
      value={selectedValues}
      onChange={handleSelectChange}
    >
      <Option key={-1} value={-1}>
        {intl.formatMessage({ defaultMessage: 'All Employees' })}
      </Option>
      {employees?.map(({ id, first_name, last_name }) => (
        <Option key={id} value={id}>
          {first_name} {last_name}
        </Option>
      ))}
    </Select>
  );
};

export default EmployeesFilter;
